export const convertTextValues = (value: string, textValues: string[]) => {
  switch (value) {
    case '1':
      return textValues[0];
    case '2':
      return textValues[1];
    case '3':
      return textValues[2];
    case '4':
      return textValues[3];
    default:
      return textValues[4];
  }
};

export const convertScaleValues = (value: string) => {
  switch (value) {
    case '1':
      return 1;
    case '2':
      return 3;
    case '3':
      return 5;
    case '4':
      return 8;
    default:
      return 10;
  }
};

export const capitalizeFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
